<template>



    <div class="listingCard">
        <div :class="['title-and-content', v.locked ? 'locked' : '' ]">
<!--            <div class="locker-area cursor-pointer" v-if="v.locked" @click="openDetail(v.detailUrl)">-->
<!--                <h1><span class="iconify" data-icon="clarity:lock-solid" data-height="50px" data-inline="false"></span> Upgrade To Unlock</h1>-->
<!--            </div>-->
            <div class="title-and-date" >
                <h3 :class="'text-capitalize text-truncate ' + (v.locked ? 'text-danger' : '') "  :title="v.title" >{{ v.title }}
                    <Bookmark :product-title="v.title" v-if="! v.locked"  type="viral" :is-winning="v.is_winning" :id="v.id" :is-bookmark="v.bookmarked" :key="v.id+v.bookmarked" />
                </h3>

            </div>
            <div class="products-rates mt-3" style="width: 100%;">
                <InfoBox title="Trend Rise in Last 24 Hours" value-style="color: #0abd0a;" :val="v.rating" :content="hc.text_trend_viral" :locked="v.locked"/>
                <InfoBox styleh6="width: 45% !important;"  title="Estimated Volume in Last 24 Hours" :val="v.volume" :content="hc.text_volume_viral" :locked="v.locked"/>
                <InfoBox title="Country" :val="v.country_code.toUpperCase()" :content="$filters.initCap(v.country_name)" :locked="v.locked"/>
            </div>
            <div>
                <inertia-link v-if="! v.locked" :href="v.detailUrl" class="show-details-btn">Show Details</inertia-link>
                <a v-else :href="v.detailUrl" class="show-details-btn bg-danger text-white">Upgrade To Unlock</a>
            </div>
        </div>
        <div class="img">
            <div class="locked-area cursor-pointer" v-if="v.locked" @click="openDetail(v.detailUrl)">
                <span class="iconify" data-height="50px" data-icon="dashicons:lock-alt" data-inline="false"></span>
            </div>
            <img onerror="this.onerror=null;this.src='/images/default/product.png'" :src="v.featured_image" :alt="v.title" loading="lazy" />
        </div>
    </div>
</template>

<script>
import PageLoading from "./PageLoading";
import Pagination from "@s/Components/Inertia/IPagination";
import Bookmark from "./Bookmark";
import DateRangeButton from "@s/Components/DateRangeButton";
import InfoRating from "./InfoRating";
import InfoBox from "./InfoBox";

export default {
    name: "ListViral",
    components: {
        DateRangeButton,
        PageLoading,
        'pagination': Pagination,
        Bookmark, InfoRating, InfoBox,
    },
    data() {
        return {
            hc: __st.hc,
        }
    },
    props: {
      v: { required: true },
    },
    methods: {
        openDetail(url) {
            location.href = url;
        }
    }
}
</script>


<style scoped>
    .title-and-content {
        width: 82% !important;
    }

    @media screen and (max-width: 676px)
    {
        #listing-card-page .listingCard > div.title-and-content {
            width: 100%;
            -ms-grid-row: 2;
            -ms-grid-row-span: 3;
            grid-row: 2 / 4;
            -ms-grid-column: 1;
            -ms-grid-column-span: 12;
            grid-column: 1 / 12;
            width: 100%;
        }
    }
</style>
